module.exports = __webpack_public_path__ + "img/line1.a4d0556b.jpg";